export function normalizeArray(entries, newMax = 1, newMin = 0) {
  const min = entries.reduce((b, a) => Math.min(b, a))
  const max = entries.reduce((b, a) => Math.max(b, a))

  return entries.map(
    (e) => ((e - min) / (max - min)) * (newMax - newMin) + newMin
  )
}

export function getEveryNth(array, n = 2, offset = 0) {
  const entries = []
  for (let i = offset; i < array.length; i += n) {
    entries.push(array[i]) //* -1 +inputArray[i+1])
  }
  return entries
}

export function pow(array, power = 2) {
  return array.map((a) => Math.pow(a, power))
}

export function fadeInOut(array, cutPercentage = 0.07) {
  const cutEntries = cutPercentage * array.length
  for (let i = 0; i < cutEntries; i++) {
    array[i] = (array[i] * i) / cutEntries
    array[array.length - i - 1] = (array[array.length - i - 1] * i) / cutEntries
  }
  return array
}

export function averageArray(array, numElementsToAverage = 2) {
  const result = []
  for (let i = 0; i < array.length; i += numElementsToAverage) {
    let a = 0
    for (let j = i; j < array.length && j < i + numElementsToAverage; j++) {
      a += array[j] / numElementsToAverage
    }
    result.push(a)
  }
  return result
}
